export default __webpack_public_path__ + "static/gleb_bahmutov-78f932731aef1090e7ad2bf84667e72a.jpg";